export default __webpack_public_path__ + "static/media/Omnisource_TnC.663ba2b2.pdf";